import React, { useEffect }  from 'react';

import {  Link, useHistory } from "react-router-dom";
import moment from "moment";

import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import IconButton from '@material-ui/core/IconButton'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import MaterialTable from 'material-table'

//service
import ConnectionService from '../../services/ConnectionsService'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop:20,
  },
  paper: {
    padding: theme.spacing(2),    
    color: theme.palette.text.secondary,
  },
}));

export default (props) => {

    const classes = useStyles()
    const history = useHistory()
    const [data, setData] = React.useState([])

    const loadConnectors = () => {

      const response = ConnectionService.connectionSearch()
      response
      .then( resp => {
        setData(resp.data.filter(item=>!item.isDefault))       
      })
      .catch(error => console.error(error))
    }

    const handleButtonClick = (row) => {          
      history.push(`connectors/add/${row.id}`)      
    }

    const handleDelete = (row) => {          
      if (window.confirm(`Tem certeza que deseja excluir:\r ${row.description}?`)) {
      const response = ConnectionService.connectionSetupDelete(row.id)
      response
        .then(resp => {
          loadConnectors()
        })
        .catch(error => console.error(error))
      }
    }
    
    const handleAddNew = (row) => {          
      history.push(`connectors/add`)      
    }

    useEffect(() => {      
      loadConnectors()
    }, [])
    
    return (
      <Container className={classes.root} >      

        <Grid item xs={12} >
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/"  >
              <Home/>
            </Link>            
            <Typography color="textPrimary">Conectores</Typography>
          </Breadcrumbs>
        </Grid>  

        <h2>IP da Infra a ser liberado: 52.0.247.162</h2>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
                <IconButton color="primary" onClick={handleAddNew} ><AddCircleIcon /></IconButton>                                                      
            </Paper>
          </Grid>
          <Grid item xs={12}>

            <MaterialTable              
              title="Conectores"
              allowfullscreen
              data={data}        
              options={{
                search: true
              }}
              columns={[
                {
                  title: 'Descrição',
                  field: 'description',
                },
                {
                  title: 'Cadastro',
                  field: 'register',
                  render: row => moment(row.register).format('DD/MM/YYYY'),
                },
                {
                  title: 'Alteração',
                  field: 'lastUpdate',
                  render: row => moment(row.lastUpdate).format('DD/MM/YYYY'),
                },
                {
                  title: 'Empresa',
                  field: 'company',
                  render: row => row.company ? row.company.label:'',
                },  
                {
                  title: 'Driver',
                  field: 'driverClassName'                  
                },  
                {
                  title: 'URL',
                  field: 'urlConnection'                  
                },                                                    
              ]}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Editar Dataset',
                  onClick: (event, row) => handleButtonClick(row),
                },
                {
                  icon: 'delete',
                  tooltip: 'Excluir Conector',
                  onClick: (event, row) => handleDelete(row),
                },                
              ]}
            />      
          </Grid>             
        </Grid>
    </Container>
    )

}